import { UnauthorizedResponseTypes } from '@/types/ApiDtos/EleosAuthenticationResponseDto';

export default class FbaApiError {
    name: string;
    message: string;
    statusCode: number;
    reasonCode: number;
    // The offending field of a validation rejection, when the API names one.
    field: string | undefined = undefined;
    unauthorizedResponseTypes: UnauthorizedResponseTypes | undefined =
        undefined;

    constructor(message = 'Unknown Error', reasonCode = -1, statusCode = -1) {
        this.name = 'FbaApiError';
        this.message = message;
        this.statusCode = statusCode;
        this.reasonCode = reasonCode;
    }
}
